// components/RefundModal.js
import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const RefundModal = ({
  refundModalOpen,
  handleCloseRefundModal,
  refundType,
  setRefundType,
  refundAmount,
  setRefundAmount,
  refundRemarks,
  setRefundRemarks,
  handleRefundSubmit,
}) => {
  return (
    <Modal
      open={refundModalOpen}
      onClose={handleCloseRefundModal}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 2,
          width: 400,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Refund Details
        </Typography>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Refund Type</InputLabel>
          <Select
            value={refundType}
            onChange={(e) => setRefundType(e.target.value)}
            fullWidth
          >
            <MenuItem value="Refund">Refund</MenuItem>
            <MenuItem value="Penalty">Penalty</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Amount"
          value={refundAmount}
          onChange={(e) => setRefundAmount(e.target.value)}
          sx={{ mt: 2 }}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Remarks"
          value={refundRemarks}
          onChange={(e) => setRefundRemarks(e.target.value)}
          sx={{ mt: 2 }}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            mt: 2,
          }}
        >
          <Button
            onClick={handleRefundSubmit}
            variant="contained"
            color="primary"
            sx={{ mb: 1 }}
          >
            Submit
          </Button>
          <Button
            onClick={handleCloseRefundModal}
            variant="outlined"
            color="secondary"
            sx={{ mb: 1 }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default RefundModal;
